<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{isCreating?'Crea un puesto':'Edita un puesto'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label for="name" class="form-label">Nombre del puesto<span
							class="required">*</span></label>
						<input type="text" placeholder="Ingresa el nombre del puesto" name="name"
							id="name" [(ngModel)]="newPosition.name" class="form-control">
					</div>
					<div class="form-group">
						<label for="area" class="form-label">Departamento del puesto<span
							class="required">*</span></label>
						<select name="area" id="area" class="form-select" [(ngModel)]="newPosition.department">
							<option *ngFor="let department of departments" value="{{department.id}}">{{department.name}}</option>
						</select>
					</div>
					<div class="form-group">
						<label for="position" class="form-label">Jefe inmediato del puesto</label>
						<select name="position" id="position" [(ngModel)]="newPosition.superior" class="form-select">
							<option *ngFor="let position of positions" value="{{position.id}}">{{position.name}}</option>
						</select>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'crear el puesto':'guardar los cambios'}} </p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!newPosition.name || !newPosition.department || loading"
						(click)="createOrEdit()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>{{isCreating?'CREAR':'EDITAR'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>